import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private apiUrl = environment.apiUrl;
  
  private userInfoSubject = new BehaviorSubject<any | null>(null);
  public userInfo$ = this.userInfoSubject.asObservable();

  constructor(private http: HttpClient) {}

  loadUserInfo(): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/auth/user-info`, { withCredentials: true })
      .pipe(
        tap(user => this.userInfoSubject.next(user)),
        catchError(err => {
          this.userInfoSubject.next(null);
          return throwError(() => err);
        })
      );
  }

  get currentUser(): any | null {
    return this.userInfoSubject.value;
  }

  clear() {
    this.userInfoSubject.next(null);
  }
}
